import { useState, useEffect } from 'react';
import { FETCHED_OBJECTS } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { useGetDataSource } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSource';
import { DATA_SOURCE_COUNT_LIMIT } from 'automation-ui-formula-editor/fetch-object-panel/constants/fetchObjectPanelConstants';
function useAddDataSourceLimit() {
  const {
    data,
    loading
  } = useGetDataSource({
    prefix: FETCHED_OBJECTS
  });
  const [dataSourceCount, setDataSourceCount] = useState(-1);
  const [isOverDataSourceCountLimit, setIsOverDataSourceCountLimit] = useState(false);
  useEffect(() => {
    if (loading || !data) {
      return;
    }
    const {
      dataSourceDefinition
    } = data;
    if (dataSourceDefinition && dataSourceDefinition.children) {
      setDataSourceCount(dataSourceDefinition.children.length);
      setIsOverDataSourceCountLimit(dataSourceDefinition.children.length >= DATA_SOURCE_COUNT_LIMIT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, loading]);
  return {
    loading: dataSourceCount < 0,
    dataSourceCount,
    isOverDataSourceCountLimit
  };
}
export default useAddDataSourceLimit;